export const RESET_ERROR = 'RESET_ERROR';
export const LOADING = 'LOADING';
export const NEW_MARKUP_SUCCESS = 'NEW_MARKUP_SUCCESS';
export const NEW_MARKUP_FAIL = 'NEW_MARKUP_FAIL';
export const MARKUP_LIST_SUCCESS = 'MARKUP_LIST_SUCCESS';
export const MARKUP_LIST_FAIL = 'MARKUP_LIST_FAIL';



